import React from 'react'

import { useLocation } from 'react-router-dom'

import { LOGIN_PROVIDER } from 'definitions'
import { useStores } from 'stores'
import SsoLogin from './SsoLogin'

import AutosphereLogo from 'assets/images/clients/autosphere.png'
import InterparkingLogo from 'assets/images/clients/interparking.svg'
import ArgentaLogo from 'assets/images/clients/argenta.png'

export default ({ loginProvider }) => {
  const { oidcStore } = useStores()
  const location = useLocation()
  let logo = null

  if (loginProvider === LOGIN_PROVIDER.INTERPARKING) {
    logo = InterparkingLogo
  } else if (loginProvider === LOGIN_PROVIDER.AUTOSPHERE) {
    logo = AutosphereLogo
  } else if (loginProvider === LOGIN_PROVIDER.ARGENTA) {
    logo = ArgentaLogo
  }

  return (
    <SsoLogin
      ssoStore={oidcStore}
      loginProvider={loginProvider}
      loginUrl={location.pathname}
      location={location}
      logo={logo}
    />
  )
}
